import axiosInstance from "../services/AxiosInstance";

export function getArtistsApi({ page, search, limit }) {
  return axiosInstance.get(
    `artist?page=${page}&search=${search}&limit=${limit}`
  );
}

export function getArtistByIdApi(id) {
  return axiosInstance.get(`artist/${id}`);
}
// export function formatPosts(postsData) {
//   let posts = [];
//   for (let key in postsData) {
//     posts.push({ ...postsData[key], id: key });
//   }

//   return posts;
// }
